import type { ReactElement } from 'react';

import BpkSmallAIIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/ai';

import STYLES from './CardIcon.module.scss';

type Props = {
  id: string;
};

export const CardIcon = ({ id }: Props): ReactElement | null => {
  switch (id) {
    case 'round-trip':
    case 'copy-paste':
      return (
        <div className={STYLES.iconWrapper}>
          <BpkSmallAIIcon aria-hidden />
        </div>
      );
    default:
      return null;
  }
};
